export default __webpack_public_path__ + "static/media/Nunito-Light.abdadce6.ttf";